import { useCallback, useEffect, useState } from 'react';

const REVIEW_MODE_SHOW_ANSWERS_KEY = 'review-mode-show-answers-by-default';
const REVIEW_MODE_SHOW_ANSWERS_EVENT = 'review-mode-show-answers-updated';

const readReviewAnswerDefault = () => {
  if (!window?.localStorage) {
    return false;
  }

  return window.localStorage.getItem(REVIEW_MODE_SHOW_ANSWERS_KEY) === 'true';
};

export const useReviewAnswerDefault = () => {
  const [showAnswersByDefault, setShowAnswersByDefaultState] = useState(() =>
    typeof window === 'undefined' ? false : readReviewAnswerDefault(),
  );

  useEffect(() => {
    const syncStoredValue = () => {
      setShowAnswersByDefaultState(readReviewAnswerDefault());
    };

    window.addEventListener('storage', syncStoredValue);
    window.addEventListener(
      REVIEW_MODE_SHOW_ANSWERS_EVENT,
      syncStoredValue as EventListener,
    );

    return () => {
      window.removeEventListener('storage', syncStoredValue);
      window.removeEventListener(
        REVIEW_MODE_SHOW_ANSWERS_EVENT,
        syncStoredValue as EventListener,
      );
    };
  }, []);

  const setShowAnswersByDefault = useCallback((value: boolean) => {
    setShowAnswersByDefaultState(value);

    if (window?.localStorage) {
      window.localStorage.setItem(
        REVIEW_MODE_SHOW_ANSWERS_KEY,
        value ? 'true' : 'false',
      );
    }

    window.dispatchEvent(new Event(REVIEW_MODE_SHOW_ANSWERS_EVENT));
  }, []);

  return { showAnswersByDefault, setShowAnswersByDefault };
};

